/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum BenefitsChargeTypeBaseNoneApiModel {
  None = 'none',

  RegularBonuses = 'regular-bonuses',

  PromotionalBonuses = 'promotional-bonuses',

  SpecialAccount = 'special-account'
}
